import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import ButtonGroupButton from '~/components/base/ButtonGroupButton';

import { getSectionSpacing } from '~/utilities/spacing';

const ButtonGroupRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: ${({ justify }) => justify};
    flex-wrap: wrap;
    gap: 10px;
    ${({ marginTop }) => getSectionSpacing(marginTop, 'margin-top')};
`;

const ButtonGroup = ({ links, marginTop = 'none', justify = 'center' }) => {
    return links?.length ? (
        <ButtonGroupRow {...{ marginTop, justify }}>
            {links.map(
                ({
                    url,
                    title,
                    icon,
                    useComparisonTable,
                    comparisonTableProductCategory,
                    addWashButton
                }) => (
                    <ButtonGroupButton
                        key={`${url}--${title}`}
                        {...{
                            url,
                            title,
                            icon,
                            addWashButton,
                            useComparisonTable,
                            comparisonTableProductCategory
                        }}
                    />
                )
            )}
        </ButtonGroupRow>
    ) : null;
};

ButtonGroup.propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            icon: PropTypes.string,
            useComparisonTable: PropTypes.bool,
            comparisonTableProductCategory: PropTypes.string,
            addWashButton: PropTypes.bool
        })
    ).isRequired,
    marginTop: PropTypes.string,
    justify: PropTypes.string
};

export default ButtonGroup;
